'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const SuccessStyled = styled__default["default"].div.withConfig({
  componentId: "sc-19ivz7a-0"
})(_ref => {
  let {
    s
  } = _ref;
  return {
    border: '1px solid #3DA97B',
    borderRadius: '4px',
    background: 'rgba(61, 169, 123, 0.1)',
    color: '#000000',
    boxSizing: 'border-box',
    padding: '16px',
    textAlign: 'left',
    fontSize: '14px',
    lineHeight: '20px',
    fontFamily: (s === null || s === void 0 ? void 0 : s.fontFamily) || 'inherit'
  };
});

exports["default"] = SuccessStyled;
